import { useEffect } from 'react'
import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/downloads/DownloadDesignsystem'

const Download: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <CustomHead
        keyword={'デザインシステム figma 発注 ガイドライン'}
        image={'https://aitria.co.jp/images/img/download/design-system/ogp.png'}
        url={'https://aitria.co.jp/download/design-system/'}
        title="デザインシステム発注ガイド | 資料ダウンロード | Aitria（アイトリア）"
        description="デザインマネージャーも安心！スケールするプロダクトのための実装から運用まで見据えた、デザインシステムの発注の際に使えるガイドラインです。"
      />
      <Template />
    </>
  )
}

export default Download
